<template lang="pug">
  .ip-address-control
    .ip-address-part(v-for="idx in [0,1,2,3]")
      .input-container
        input.form-control(:class="{focus: idx === 0}" type="text" v-model="ip[idx]" @keydown="filterKey" maxlength="3" max="255" min="0")
      span(v-if="idx < 3") .
</template>

<script>
export default {
  props: ['value'],
  created() {
    this.parseIp()
  },
  data() {
    return {
      ip: [0, 0, 0, 0]
    }
  },
  // TODO: watcher for value
  methods: {
    filterKey(e) {
      const allowed = ['Tab', 'Backspace', 'ArrowLeft', 'ArrowRight', 'Enter', 'NumpadEnter']
      if (e.key.match(/[0-9]/) || allowed.some((a) => e.code === a)) {
        this.$emit('input', this.ip.join('.'))
      } else {
        e.preventDefault()
      }
    },
    parseIp() {
      if (this.value) {
        this.ip = this.value.split('.')
      }
    }
  }
}
</script>

<style lang="scss">
  .ip-address-control {
    display: flex;
    flex-direction: row;

    border: 1px solid #cccccc;
    border-radius: 2px;
    .ip-address-part {
      display: flex;
      flex-direction: row;
      input {
        border-style: none;
        text-align: center;
      }
      span {
        margin-top: 10px
      }
      .input-container {
        flex: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/IpAddressControl.vue